import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'

const SEO = ({ url }) => {
  return (
    <StaticQuery
      query={query}
      render={({
                 campaignData: {
                   metaTitle,
                   description,
                   coverImage,
                   favicon,
                 },
                 site: {
                   siteMetadata: {
                     defaultTitle,
                     defaultDescription,
                     defaultFavicon,
                   },
                 },
               }) => {

        const seo = {
          title: metaTitle || defaultTitle,
          description: description || defaultDescription,
          image: coverImage,
          url: `https://${url.replace('https://', '')}` || '/',
          favicon: favicon || defaultFavicon,
        }

        return (
          <Helmet title={seo.title}>
            <meta name="generator" content="Perspective Funnels" />

            <link rel="apple-touch-icon-precomposed" sizes="57x57" href={`${seo.favicon}?w=57&h=57`} />
            <link rel="apple-touch-icon-precomposed" sizes="114x114" href={`${seo.favicon}?w=114&h=114`} />
            <link rel="apple-touch-icon-precomposed" sizes="72x72" href={`${seo.favicon}?w=72&h=72`} />
            <link rel="apple-touch-icon-precomposed" sizes="144x144" href={`${seo.favicon}?w=144&h=144`} />
            <link rel="apple-touch-icon-precomposed" sizes="60x60" href={`${seo.favicon}?w=60&h=60`} />
            <link rel="apple-touch-icon-precomposed" sizes="120x120" href={`${seo.favicon}?w=120&h=120`} />
            <link rel="apple-touch-icon-precomposed" sizes="76x76" href={`${seo.favicon}?w=76&h=76`} />
            <link rel="apple-touch-icon-precomposed" sizes="152x152" href={`${seo.favicon}?w=152&h=152`} />
            <link rel="icon" type="image/png" href={`${seo.favicon}?w=196&h=196`} sizes="196x196" />
            <link rel="icon" type="image/png" href={`${seo.favicon}?w=96&h=96`} sizes="96x96" />
            <link rel="icon" type="image/png" href={`${seo.favicon}?w=32&h=32`} sizes="32x32" />
            <link rel="icon" type="image/png" href={`${seo.favicon}?w=16&h=16`} sizes="16x16" />
            <link rel="icon" type="image/png" href={`${seo.favicon}?w=128&h=128`} sizes="128x128" />

            {seo.title && <meta property="title" content={seo.title} />}
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            {seo.url && <link rel="canonical" href={seo.url} />}
            {seo.url && <meta property="og:url" content={seo.url} />}
            {seo.title && <meta property="og:title" content={seo.title} />}
            {seo.description && <meta property="og:description" content={seo.description} />}
            {seo.image && <meta property="og:image" content={seo.image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {seo.title && <meta name="twitter:title" content={seo.title} />}
            {seo.description && <meta name="twitter:description" content={seo.description} />}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
          </Helmet>
        )
      }}
    />
  )
}

export default SEO

SEO.propTypes = {
  url: PropTypes.string,
}

const query = graphql`
    query SEO {
        site {
            siteMetadata {
                defaultTitle: title
                defaultDescription: description
                defaultFavicon: favicon
            }
        }
        campaignData {
            _id
            metaTitle
            description
            coverImage
            favicon
      pages {
        _id
        isResult
      }
    }
  }
`
